export default __webpack_public_path__ + "static/media/signin-persona-health-worker.8178c53d.svg";